import { skipToken, useQuery } from '@tanstack/react-query';

import { Clips } from '@air/api';
import { type Clip, type Workspace } from '@air/api/types';

export const CLIP_KEY = '@plugin-ui/CLIP';

export const getClipKey = (params: UseClipParams) => {
  return [CLIP_KEY, params];
};

export type UseClipParams = {
  clipId: Clip['id'] | undefined;
  workspaceId: Workspace['id'] | undefined;
};

export const useClip = (params: UseClipParams) => {
  const { clipId, workspaceId } = params;

  return useQuery({
    queryFn:
      workspaceId && clipId
        ? () =>
            Clips.get({
              clipId,
              workspaceId,
            })
        : skipToken,
    queryKey: getClipKey(params),
  });
};
